import {
  TemplateVariableType,
  TemplateLayout,
  AiGenerateInputLayoutHint,
  AiGenerateInputTone,
  BrandSettingsDmarcPolicy,
  UpdateBrandSettingsInputDmarcPolicy,
  AiReplyDraftInputTone,
  ListGmailMessagesView,
  ListGmailMessagesRead,
  ListInboundEmailsView,
  ListInboundEmailsRead,
  ListInboundEmailsVerification,
  InboundVerificationStatus,
} from "@workspace/api-client-react";

type NonEmptyArray<T> = [T, ...T[]];

function values<T extends Record<string, string>>(obj: T): NonEmptyArray<T[keyof T]> {
  return Object.values(obj) as NonEmptyArray<T[keyof T]>;
}

export const VARIABLE_TYPE_VALUES = values(TemplateVariableType);
export const TEMPLATE_LAYOUT_VALUES = values(TemplateLayout);
export const AI_LAYOUT_HINT_VALUES = values(AiGenerateInputLayoutHint);
export const AI_TONE_VALUES = values(AiGenerateInputTone);
export const DMARC_POLICY_VALUES = values(BrandSettingsDmarcPolicy);
export const DMARC_POLICY_INPUT_VALUES = values(UpdateBrandSettingsInputDmarcPolicy);
export const REPLY_TONE_VALUES = values(AiReplyDraftInputTone);
export const GMAIL_VIEW_VALUES = values(ListGmailMessagesView);
export const GMAIL_READ_VALUES = values(ListGmailMessagesRead);
export const INBOUND_VIEW_VALUES = values(ListInboundEmailsView);
export const INBOUND_READ_VALUES = values(ListInboundEmailsRead);
export const INBOUND_VERIFICATION_FILTER_VALUES = values(ListInboundEmailsVerification);
export const INBOUND_VERIFICATION_STATUS_VALUES = values(InboundVerificationStatus);

export const VARIABLE_TYPE_LABELS: Record<TemplateVariableType, string> = {
  [TemplateVariableType.text]: "Text",
  [TemplateVariableType.textarea]: "Textarea",
  [TemplateVariableType.url]: "URL",
  [TemplateVariableType.email]: "Email",
  [TemplateVariableType.number]: "Number",
  [TemplateVariableType.date]: "Date",
};

export const LAYOUT_LABELS: Record<TemplateLayout, string> = {
  [TemplateLayout.minimal]: "Minimal",
  [TemplateLayout.corporate]: "Corporate",
  [TemplateLayout.modern_saas]: "Modern SaaS",
  [TemplateLayout.financial]: "Financial",
  [TemplateLayout.ecommerce]: "E-Commerce",
  [TemplateLayout.alert]: "Alert",
};

export const AI_TONE_LABELS: Record<NonNullable<AiGenerateInputTone>, string> = {
  [AiGenerateInputTone.professional]: "Professional",
  [AiGenerateInputTone.friendly]: "Friendly",
  [AiGenerateInputTone.urgent]: "Urgent",
  [AiGenerateInputTone.celebratory]: "Celebratory",
  [AiGenerateInputTone.neutral]: "Neutral",
};

export const DMARC_POLICY_LABELS: Record<BrandSettingsDmarcPolicy, string> = {
  [BrandSettingsDmarcPolicy.none]: "none — monitor only (recommended start)",
  [BrandSettingsDmarcPolicy.quarantine]: "quarantine — send unaligned mail to spam",
  [BrandSettingsDmarcPolicy.reject]: "reject — bounce unaligned mail outright",
};

export const REPLY_TONE_LABELS: Record<AiReplyDraftInputTone, string> = {
  [AiReplyDraftInputTone.auto]: "Auto tone",
  [AiReplyDraftInputTone.friendly]: "Friendly",
  [AiReplyDraftInputTone.formal]: "Formal",
  [AiReplyDraftInputTone.concise]: "Concise",
};
